import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const APP_READY = 'app-ready';

export const useOnAppReady = (eventTarget: EventTarget): void => {
    const handleEvent = useCallback(() => {
        const event = new CustomEvent(APP_READY);

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('app-ready', handleEvent);

        return () => publicEventsAPIService.off('app-ready', handleEvent);
    }, [handleEvent]);
};
